// extracted by mini-css-extract-plugin
module.exports = {"loading":"Architect_loading__3v2Bt","headerCarousel":"Architect_headerCarousel__1A0W7","layout":"Architect_layout__2P3jY"};